{
  "AUDIT_LOGS": {
    "HEADER": "稽核日誌",
    "HEADER_BTN_TXT": "新增稽核日誌",
    "LOADING": "正在載入稽核日誌",
    "DESCRIPTION": "稽核日誌記錄您帳戶中的所有活動，讓您可以追蹤與稽核帳戶、團隊或服務的異動。",
    "LEARN_MORE": "了解更多關於稽核日誌的資訊",
    "SEARCH_404": "沒有符合此查詢的項目",
    "SIDEBAR_TXT": "<p><b>稽核日誌</b></p><p>稽核日誌記錄 Chatwoot 系統中的事件與操作軌跡。</p>",
    "LIST": {
      "404": "此帳戶中沒有可用的稽核日誌。",
      "TITLE": "管理稽核日誌",
      "DESC": "稽核日誌記錄 Chatwoot 系統中的事件與操作軌跡。",
      "TABLE_HEADER": {
        "ACTIVITY": "活動",
        "TIME": "時間",
        "IP_ADDRESS": "IP 位址"
      }
    },
    "API": {
      "SUCCESS_MESSAGE": "稽核日誌取得成功",
      "ERROR_MESSAGE": "無法連線至伺服器，請稍後再試。"
    },
    "DEFAULT_USER": "系統",
    "AUTOMATION_RULE": {
      "ADD": "{agentName} 建立了新的自動化規則（#{id}）",
      "EDIT": "{agentName} 更新了自動化規則（#{id}）",
      "DELETE": "{agentName} 刪除了自動化規則（#{id}）"
    },
    "ACCOUNT_USER": {
      "ADD": "{agentName} 邀請 {invitee} 以 {role} 身分加入帳戶",
      "EDIT": {
        "SELF": "{agentName} 將自己的 {attributes} 變更為 {values}",
        "OTHER": "{agentName} 將 {user} 的 {attributes} 變更為 {values}",
        "DELETED": "{agentName} 將已刪除使用者的 {attributes} 變更為 {values}"
      }
    },
    "INBOX": {
      "ADD": "{agentName} 建立了新的收件匣（#{id}）",
      "EDIT": "{agentName} 更新了收件匣（#{id}）",
      "DELETE": "{agentName} 刪除了收件匣（#{id}）"
    },
    "WEBHOOK": {
      "ADD": "{agentName} 建立了新的 Webhook（#{id}）",
      "EDIT": "{agentName} 更新了 Webhook（#{id}）",
      "DELETE": "{agentName} 刪除了 Webhook（#{id}）"
    },
    "USER_ACTION": {
      "SIGN_IN": "{agentName} 已登入",
      "SIGN_OUT": "{agentName} 已登出"
    },
    "TEAM": {
      "ADD": "{agentName} 建立了新的團隊（#{id}）",
      "EDIT": "{agentName} 更新了團隊（#{id}）",
      "DELETE": "{agentName} 刪除了團隊（#{id}）"
    },
    "MACRO": {
      "ADD": "{agentName} 建立了新的巨集（#{id}）",
      "EDIT": "{agentName} 更新了巨集（#{id}）",
      "DELETE": "{agentName} 刪除了巨集（#{id}）"
    },
    "INBOX_MEMBER": {
      "ADD": "{agentName} 將 {user} 新增至收件匣（#{inbox_id}）",
      "REMOVE": "{agentName} 將 {user} 從收件匣（#{inbox_id}）中移除"
    },
    "TEAM_MEMBER": {
      "ADD": "{agentName} 將 {user} 新增至團隊（#{team_id}）",
      "REMOVE": "{agentName} 將 {user} 從團隊（#{team_id}）中移除"
    },
    "ACCOUNT": {
      "EDIT": "{agentName} 更新了帳戶設定（#{id}）"
    },
    "CONVERSATION": {
      "DELETE": "{agentName} 刪除了對話 #{id}"
    }
  }
}
